var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIconHeadset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.346,
    height: 17.323,
    viewBox: "0 0 19.346 17.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-headset",
    "data-name": "Icon awesome-headset",
    d: "M7.255,7.038A1.151,1.151,0,0,0,6.046,5.955h-.6A2.3,2.3,0,0,0,3.023,8.12V9.744A2.3,2.3,0,0,0,5.441,11.91h.6a1.151,1.151,0,0,0,1.209-1.083ZM13.9,11.91a2.3,2.3,0,0,0,2.418-2.165V8.12A2.3,2.3,0,0,0,13.9,5.955h-.6a1.151,1.151,0,0,0-1.209,1.083v3.789A1.151,1.151,0,0,0,13.3,11.91ZM9.673,0C4.277,0,.173,4.021,0,8.662V9.2a.575.575,0,0,0,.6.541h.6a.575.575,0,0,0,.6-.541V8.662c0-3.881,3.526-7.038,7.859-7.038s7.859,3.157,7.859,7.038h0c0,.082,0,5.607,0,5.607a1.521,1.521,0,0,1-1.6,1.431H12.091a1.727,1.727,0,0,0-1.814-1.624H9.068A1.727,1.727,0,0,0,7.255,15.7a1.727,1.727,0,0,0,1.814,1.624h6.866a3.248,3.248,0,0,0,3.411-3.055V8.662C19.173,4.021,15.07,0,9.673,0Z",
    fill: "#4477c0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconHeadset);
export default __webpack_public_path__ + "static/media/nav-icon-headset.2cb84265c238253530eae2811cc62143.svg";
export { ForwardRef as ReactComponent };